class FreeGiftItem extends HTMLElement {
  connectedCallback() {
    this.buttonEl.addEventListener('click', this.handleSubmit.bind(this))
  }

  handleSubmit(e) {
    const property = this.dataset.lineProperty
    const variantId = this.dataset.variantId

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': {
          [property]: true,
        }
      }]
    }

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error.message)
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }))
      })
  }

  get buttonEl() {
    return this.querySelector('button[type="submit"]')
  }
}

customElements.define('free-gift-item', FreeGiftItem)
